import React from "react";
import { IconSquareButtonContainer } from "./styles";

type PaletteColor = "primary" | "secondary" | "success" | "error";

type DivProps = React.HTMLAttributes<HTMLDivElement>;

interface IconSquareButtonProps extends Omit<DivProps, "color"> {
  icon: React.ReactElement;
  color?: PaletteColor;
  disabled?: boolean;
}

export const IconSquareButton = React.forwardRef<HTMLDivElement, IconSquareButtonProps>(
  ({ icon, color = "primary", onClick, disabled, title, ...rest }, ref) => {
    return (
      <IconSquareButtonContainer
        ref={ref}
        elevation={0}
        btncolor={color}
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
        role="button"
        aria-disabled={disabled}
        title={title}
        {...rest}
      >
        {React.cloneElement(icon, {
          // garante que o ícone use a cor herdada do container
          htmlColor: undefined,
          color: "inherit" as any
        })}
      </IconSquareButtonContainer>
    );
  }
);

IconSquareButton.displayName = "IconSquareButton";


